import React from 'react';
import { motion } from 'framer-motion';
import { AnchorIcon, NavigationIcon, ShipIcon, ShieldCheckIcon } from 'lucide-react';
export function About() {
  return <section id="o-akci" className="w-full bg-off-white py-24 px-6 scroll-mt-20" data-id="element-23" data-mp="2tt25678bpvdy">
      <div className="max-w-6xl mx-auto" data-id="element-24" data-mp="2ys5bdv01i7ni">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-25" data-mp="2yt7zjv5z9vzq">
          {/* Left column */}
          <div className="space-y-8" data-id="element-26" data-mp="3hhv84nnd53i2">
            <img src="https://cdn.magicpatterns.com/uploads/6ikzqbMg3YKiQTBTLZDAFn/FutureChallenge.svg" alt="FUTURE CHALLENGE" className="block h-10 md:h-14 w-auto" data-id="element-27" data-mp="3mhzkc1h8nc2h" />

            <div className="rounded-2xl overflow-hidden shadow-md" data-id="element-28" data-mp="2lsa6o6o27uf6">
              <img src="https://cdn.magicpatterns.com/uploads/2iGFN2sHZ72jzpWMpYnUu2/16-9-fullframe-export_(0;01;44;15)_detI.jpg" alt="Plachetnice při západu slunce" className="w-full h-64 md:h-72 object-cover" data-id="element-29" data-mp="2gse1w57jfyyk" />
            </div>

            <div className="space-y-4 text-navy-deep/80" data-id="element-30" data-mp="34hp5dug9w7ge">
              <p className="text-xl font-medium text-navy-deep leading-relaxed" data-id="element-31" data-mp="34h73ah6xiz0k">
                Jak jsme si na jaře 2025 poprvé vyzkoušeli a docela se to
                povedlo i v roce 2026, připravili jsme pro květen 2027 další
                ročník akce plné zážitků při společné plavbě s prvky závodění na
                plachetnicích.
              </p>
              <p className="leading-relaxed" data-id="element-32" data-mp="3o67mrpv1egkj">
                Akce nebude oficiálně kvůli legislativě vyhlášena jako závod.
                Závodit se bude formou navigačních rozjížděk o různých délkách
                dle propozic rozhodčího. Nebudou se používat bóje.
              </p>
            </div>
          </div>

          {/* Right column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-mist lg:sticky lg:top-24 lg:mt-[72px] pt-[40px] mt-[86px]" data-id="element-33" data-mp="b717on0u5pqa">
            <h3 className="text-2xl font-semibold text-navy-deep mb-8 flex items-center gap-3" data-id="element-34" data-mp="3amenu19q0a6p">
              <img src="https://cdn.magicpatterns.com/uploads/oR2yze7yVUcg2uRAatZj5v/FCh_logo_Blue.svg" alt="Future Challenge logo" width="40" height="40" className="h-10 w-auto block" data-id="element-35" data-mp="3enq7lq5wy16z" />
              Základní představa
            </h3>

            <ul className="space-y-6" data-id="element-36" data-mp="2tb9f6tne6fbu">
              <li className="flex gap-4" data-id="element-37" data-mp="2tcarf1g597v5">
                <div className="mt-1 bg-mist p-2 rounded-full text-blue-medium shrink-0" data-id="element-38" data-mp="3724gnkvk9u5e">
                  <ShipIcon className="w-5 h-5" data-id="element-39" data-mp="373z4p824q2dp" />
                </div>
                <div data-id="element-40" data-mp="329ur45ycyw3n">
                  <strong className="block text-navy-deep" data-id="element-41" data-mp="329l2omsyox02">
                    ONE DESIGN flotila
                  </strong>
                  <span className="text-navy-deep/70" data-id="element-42" data-mp="3c1qspqznl4cm">
                    Startovní pole do 10 lodí. Jedna společná rozhodcovská loď a
                    služby rozhodčího.
                  </span>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-43" data-mp="3l2f7inwvf8qk">
                <div className="mt-1 bg-mist p-2 rounded-full text-blue-medium shrink-0" data-id="element-44" data-mp="1vmzcsdjp1pk7">
                  <NavigationIcon className="w-5 h-5" data-id="element-45" data-mp="1voshhnaqxzpk" />
                </div>
                <div data-id="element-46" data-mp="1qppbo0mxzpgj">
                  <strong className="block text-navy-deep" data-id="element-47" data-mp="1qq8t7g8okbu1">
                    Navigační rozjížďky
                  </strong>
                  <span className="text-navy-deep/70" data-id="element-48" data-mp="1x3lfqsghbrwr">
                    Rozsah plavby bude 4-5 soutěžních dní. Rozpis a itinerář
                    bude zveřejňován elektronicky.
                  </span>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-49" data-mp="271j3leuffmou">
                <div className="mt-1 bg-mist p-2 rounded-full text-blue-medium shrink-0" data-id="element-50" data-mp="19ett0glns1rd">
                  <ShieldCheckIcon className="w-5 h-5" data-id="element-51" data-mp="1eddjmub761q2" />
                </div>
                <div data-id="element-52" data-mp="1ebk7izhtepao">
                  <strong className="block text-navy-deep" data-id="element-53" data-mp="1jczx94uxtjze">
                    Pravidla a bezpečnost
                  </strong>
                  <span className="text-navy-deep/70" data-id="element-54" data-mp="1o4hx1pl85eis">
                    Veškeré dění na vodě se řídí námořním právem a COLREGem.
                  </span>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-55" data-mp="vm3wvjcf1ggj">
                <div className="mt-1 bg-mist p-2 rounded-full text-blue-medium shrink-0" data-id="element-56" data-mp="vl2jh87xghvn">
                  <AnchorIcon className="w-5 h-5" data-id="element-57" data-mp="o2ux8htpow4o" />
                </div>
                <div data-id="element-58" data-mp="j5ut4cgfa3g7">
                  <strong className="block text-navy-deep" data-id="element-59" data-mp="j5b8gnze10yh">
                    Vlastní režie
                  </strong>
                  <span className="text-navy-deep/70" data-id="element-60" data-mp="e79sibx9dhr8">
                    Náklady na stravu, kotvení v marínách, pohonné hmoty a
                    dopravu do HR si hradí posádky samy.
                  </span>
                </div>
              </li>
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}